import React from 'react';
import { PopUpNotification } from 'extracted-chat-components';

import {
  ButtonColor,
  ButtonShape,
  ButtonSize,
  PopUpNotification as PopupType,
} from 'constants/enums';
import ChatEndFeedbackPopup from 'components/Popups/ChatEndFeedbackPopup';

const CustomerFinishedChatPopUp = ({
  isNotificationPopUp,
  popUpNotificationData,
  deleteCurrentChat,
  showPopUpNotification,
  setIsSwitchedConversations,
  isReadingFeedbackEnabled,
  onLeaveFeedbackNow,
  onLeaveFeedbackLater,
  isPendingEarlyLogout = false,
  setPendingEarlyLogout = (val: boolean) => val,
}) => {
  const closePopup = () => {
    deleteCurrentChat();
    showPopUpNotification(false);
    setIsSwitchedConversations(false);

    if (isPendingEarlyLogout) {
      setPendingEarlyLogout(false);
    }
  };

  const isSwitchToPhone = popUpNotificationData.notificationType
    === PopupType.SWITCH_TO_PHONE_CHAT_ENDED;

  const handleOnFeedbackNow = () => {
    if (!isSwitchToPhone) {
      onLeaveFeedbackNow();
    }

    closePopup();
  };

  if (isReadingFeedbackEnabled) {
    return (
      <ChatEndFeedbackPopup
        isOpen={isNotificationPopUp}
        title={popUpNotificationData.title}
        description={popUpNotificationData.description}
        isFixedButtonSize
        primaryBtnText={isSwitchToPhone ? 'Okay' : 'Leave Reading Feedback Now'}
        secondaryBtnText={isSwitchToPhone ? undefined : 'Leave Feedback Later'}
        onAccept={handleOnFeedbackNow}
        onCancel={() => { closePopup(); onLeaveFeedbackLater(); }}
      />
    );
  }

  const acceptButton = {
    text: 'Okay',
    color: ButtonColor.WARNING,
    size: ButtonSize.XS,
    shape: ButtonShape.ROUNDED,
    handler: closePopup,
  };

  return (
    <PopUpNotification
      isOpen={isNotificationPopUp}
      title={popUpNotificationData.title}
      isTextNewLine={popUpNotificationData.isTextNewLine}
      description={popUpNotificationData.description}
      acceptButton={acceptButton}
      rejectButton={undefined}
      isBigWidth={false}
      isRequestError={false}
    >
      {null}
    </PopUpNotification>
  );
};

export default CustomerFinishedChatPopUp;
